import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './select-option.scss?inline';

export default class SotbitSelectOption extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        value: { type: String, reflect: true },
        disabled: { type: Boolean, reflect: true },
        selected: { type: Boolean, reflect: true },
        multiple: { type: Boolean, reflect: true },
        label: { type: String },
        hasIconSlots: { type: Boolean, state: true },
    };

    constructor() {
        super();
        this.value = '';
        this.disabled = false;
        this.selected = false;
        this.multiple = false;
        this.iconLeftSlots = null;
        this.iconRightSlots = null;
    }

    setHasIconSlots() {
        this.hasIconSlots = this.iconLeftSlots.length > 0 || this.iconRightSlots > 0;
    }

    _handleIconLeftSlotChange({ currentTarget }) {
        this.iconLeftSlots = currentTarget.assignedElements({ flatten: true });
        this.setHasIconSlots();
    }

    _handleIconRightSlotChange({ currentTarget }) {
        this.iconRightSlots = currentTarget.assignedElements({ flatten: true });
        this.setHasIconSlots();
    }

    getLeftIcons() {
        return this.iconLeftSlots;
    }

    getRightIcons() {
        return this.iconRightSlots;
    }

    updated(changedProperties) {
        if (changedProperties.has('selected') && typeof changedProperties.has('selected') !== 'undefined') {
            this.dispatchEvent(
                new CustomEvent('change-selected', {
                    bubbles: true,
                    composed: true,
                })
            );
        }
    }

    render() {
        return html`
            <div class="option" part="option">
                ${this.multiple
                    ? html` <div class="option__checkbox-box" part="option-checkbox-box">
                          <sotbit-checkbox
                              part="option-checkbox"
                              .checked=${this.selected}
                              ?disabled=${this.disabled}
                              tabindex="-1"
                          ></sotbit-checkbox>
                      </div>`
                    : ''}
                <slot @slotchange="${this._handleIconLeftSlotChange}" name="icon-left"></slot>
                <div part="caption">
                    <slot></slot>
                </div>
                <slot @slotchange="${this._handleIconRightSlotChange}" name="icon-right"></slot>
            </div>
        `;
    }
}
